import { MESFMain } from "@dexteel/mesf-core";
import "react-datepicker/dist/react-datepicker.css";
import { render } from "react-dom";
import "./app.css";
import "./setup/ag-grid-license";

import { AuthenticationConfig } from "@setup/auth-config";
import { customConfigurations } from "@setup/configurations";
import { CustomNavbar } from "@setup/navbar";
import { CustomRoutes } from "@setup/routes";

// Logbook configuration
const logbookSettings = {
	entry: {
		withAssetFilter: "tree" as const,
		canEditAsset: true,
		allowAttachments: true,
		canEditShift: true,
		showShiftCrew: true,
		exportToExcel: true,
		shiftsRange: 7,
	},
	report: {
		withAssetFilter: "tree" as const,
		showAttachments: true,
		showAsset: true,
		showShiftCrew: true,
		exportToExcel: true,
	},
};

render(
	<MESFMain
		routes={CustomRoutes}
		navbar={CustomNavbar}
		navbarTitle="RBD-CMMS"
		showAreaSelector={true}
		showTrendingsIcon={false}
		configurations={customConfigurations}
		authentication={AuthenticationConfig}
		logbookSettings={logbookSettings}
	/>,
	document.getElementById("root"),
);
